import module from '@kendu/ui/module'
import './style.scss'

class kdDialogTitleComponent {
}

module.component('kdDialogTitle', {
  controller: kdDialogTitleComponent,
})



// WEBPACK FOOTER //
// ./src/kendu/ui/components/kd-dialog-title/component.js